export const MEASUREMENT_SYSTEM = {
  IMPERIAL: 'IMPERIAL',
  METRIC: 'METRIC',
};
